export default {
	install(Vue, options) {
		if (typeof TiaraTracker === 'undefined') return;
		const tiaraInstance = TiaraTracker.getInstance();

		const trackPage = () => {
			tiaraInstance.setSvcDomain('top.cafe.daum.net')
				.setSection('top')
				.setPage(options.pageName)
				.setSessionTimeout('1800')
				.setDeployment(IS_DEV ? 'dev' : 'production')
				.setIgnoreQueryParams(['ts', 'dummy'])
				.trackPage(options.pageName)
				.customProps(options.customProps || {})
				.track();
		};

		const trackEvent = ({ layer, desc, url='', customProps={} }) => {
			const clickObject = {
				layer1: layer,
				layer2: '',
				layer3: '',
				click_url: url.slice(0, 255),
				copy: '',
				posx: 0,
				posy: 0
			};

			tiaraInstance
				.trackEvent(`카페탑>${options.pageNameDesc}>${desc}`)
				.click(clickObject)
				.customProps(customProps)
				.track();
		};

		Vue.prototype.$trackEvent = trackEvent;
		Vue.prototype.$trackPage = trackPage;

		Vue.directive('tiara', {
			bind(el, binding) {
				el.addEventListener('click', (e) => {
					trackEvent({
						layer: binding.value.layer,
						desc: binding.value.desc,
						url: e.currentTarget.href || '',
						customProps: binding.value.customProps || {}
					});
				});
			}
		});
	}
}
